import styled from 'styled-components'
// components
import HeaderOrigin from 'components/UI/Modal/Header'
// themes
import { colors } from 'themes/index'
// utils
import { darken, ellipsis, transparentize } from 'polished'

export const Text = styled.div`
  padding: 20px;
  font-size: 16px;
`

export const ButtonContainer = styled.div`
  padding: 20px;
  display: flex;
  gap: 16px;
  background-color: ${colors.gray200};
  border-top: 2px solid ${darken(0.1, colors.gray200)};
`

export const Header = styled(HeaderOrigin)`
  && {
    background: repeating-linear-gradient(
      135deg,
      ${transparentize(0.1, colors.red300)},
      ${transparentize(0.1, colors.red300)} 40px,
      ${colors.red300} 40px,
      ${colors.red300} 80px
    );

    ${ellipsis('100%')};
  }
`
